export default __webpack_public_path__ + "static/media/mixkit-modern-classic-door-bell-sound-113.20e6a003.wav";